var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueLogomark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655,
    height: 655,
    viewBox: "0 0 655 655",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M655 327.5C655 508.373 508.373 655 327.5 655C146.627 655 0 508.373 0 327.5C0 146.627 146.627 0 327.5 0C508.373 0 655 146.627 655 327.5Z",
    fill: "#0070FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M346.877 389.805C314.967 400.174 280.693 382.71 270.324 350.8C259.956 318.889 277.419 284.615 309.33 274.246C341.241 263.878 375.515 281.341 385.883 313.252C396.251 345.163 378.788 379.437 346.877 389.805Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.516 89.0273H389.021V332.039H267.516V89.0273Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 314.789L115.547 199.23L346.665 274.325L309.117 389.884L78 314.789Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M519.977 492.762L421.676 564.181L278.838 367.58L377.138 296.161L519.977 492.762Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M540.453 199.148L578 314.707L346.883 389.802L309.336 274.243L540.453 199.148Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.492 564.473L136.192 493.053L279.03 296.453L377.331 367.872L234.492 564.473Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogomark);
export default __webpack_public_path__ + "static/media/blue-logomark.679476073a01c63801194ddc600aafaa.svg";
export { ForwardRef as ReactComponent };